/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SigninErrors = {
    RememberThisDeviceInvalid: 'REMEMBER_THIS_DEVICE_INVALID'
} as const;
export type SigninErrors = typeof SigninErrors[keyof typeof SigninErrors];


export function instanceOfSigninErrors(value: any): boolean {
    for (const key in SigninErrors) {
        if (Object.prototype.hasOwnProperty.call(SigninErrors, key)) {
            // @ts-ignore
            if (SigninErrors[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SigninErrorsFromJSON(json: any): SigninErrors {
    return SigninErrorsFromJSONTyped(json, false);
}

export function SigninErrorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigninErrors {
    return json as SigninErrors;
}

export function SigninErrorsToJSON(value?: SigninErrors | null): any {
    return value as any;
}

